import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import BodyClassName from 'react-body-classname';
import classnames from 'classnames';

import EventDetails from '../../containers/event/event-details';
import PurchaseRequest from '../../containers/event/purchase-request';
import AfterAction from '../../containers/event/after-action';
import hasRequiredPermissions from '../../helpers/hocs/has-required-permissions';

import ErrorPage from '../errorPage';

class AddEvent extends Component {
    componentDidMount() {
        hasRequiredPermissions({ Event: ['Create, Review'] }, ErrorPage);
        if (this.props.match.isExact && this.props.match.path === '/event') {
            this.props.resetEvent();
        }
    }

    componentWillReceiveProps() {
        //This will reset the event once a user clicks on that event navigation link.
        if (this.props.location.pathname === '/event') {
            this.props.resetEvent();
        }
    }

    componentWillUnmount() {
        // Will reset the event state when leaving this route of /event
        this.props.resetEvent();
    }

    render() {
        let overlayClass = classnames('form-action-overlay', {
            'is-active': this.props.eventActionLoading
        });
        return (
            <BodyClassName className="event">
                <div>
                    <div className={overlayClass}>
                        <div className="form-action-overlay__content">
                            <svg className="icon icon-logo">
                                <use xlinkHref="#icon-logo" />
                            </svg>

                            <div className="form-action-overlay__text">
                                {this.props.eventActionText}
                            </div>

                            <svg
                                className="loading__spinner"
                                width="60"
                                height="20"
                                viewBox="0 0 60 20"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <circle cx="7" cy="15" r="4" />
                                <circle cx="30" cy="15" r="4" />
                                <circle cx="53" cy="15" r="4" />
                            </svg>
                        </div>
                    </div>

                    {this.props.children}

                    <Switch>
                        <Route
                            path={`${this.props.match.path}/after-action/:tab`}
                            component={AfterAction}
                        />

                        <Route
                            path={`${this.props.match.path}/event-details/:tab`}
                            component={EventDetails}
                        />

                        <Route
                            path={`${this.props.match
                                .path}/purchase-request/:tab`}
                            component={PurchaseRequest}
                        />

                        <Redirect
                            exact
                            from="/event"
                            to="/event/event-details/event-information"
                        />

                        <Redirect
                            exact
                            from="/event/event-details"
                            to="/event/event-details/event-information"
                        />

                        <Redirect
                            exact
                            from="/event/purchase-request"
                            to="/event/purchase-request/basic-info-line-item"
                        />

                        <Redirect
                            exact
                            from="/event/after-action"
                            to="/event/after-action/general"
                        />

                        <Route
                            path={`${this.props.match.path}/:id`}
                            render={({ match }) => (
                                <Redirect
                                    to={{
                                        pathname:
                                            '/event/event-details/event-information',
                                        state: { eventId: match.params.id }
                                    }}
                                />
                            )}
                        />

                        <Route component={ErrorPage} />
                    </Switch>
                </div>
            </BodyClassName>
        );
    }
}

export default AddEvent;



// WEBPACK FOOTER //
// ./src/components/event/index.js